
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dating",
      function () {
        return require("private-next-pages/dating.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dating"])
      });
    }
  